import * as React from 'react'
import axios from '../services/index'
import { TrainingDetailCard } from './TrainingDetailCard'

interface ITraining {
    Name: string,
    Price: Float32Array,
    Summary: string,
    PresentationVideo: string,
    VideoLink: string,
    facebookLink: string,
    googleFormLink: string,
    duration: string,
    pedagogicalMethods: string,
    objectives: string,
    detailledProgram: string,
    prerequisite: string,
}

//This component load data from server in order to display it in detail card.
export const TrainingDetail: React.FunctionComponent = (props) => {

    const currentToken = localStorage.getItem('access_token')
    const [training, setTraining] = React.useState<ITraining>()
    const [id, setId] = React.useState(window.location.href.toString().split('/')[5])
    const [presentationId, setPresentationId] = React.useState('')
    const [videoId, setVideoId] = React.useState('')
    const [isPaid, setIsPaid] = React.useState(false)

    React.useEffect(() => {
        let headerValue = {}
        if(currentToken) {
            headerValue = {
                headers: {
                    "Authorization": `Bearer ${currentToken}`
                }
            }
        }

        axios.get(`https://LaurenceBrun.eu.pythonanywhere.com/training/${id}/`, headerValue)
        .then(function (response: any) {
            setTraining({
                Name : response.data.title,
                Price : response.data.price, 
                Summary : response.data.description, 
                PresentationVideo : response.data.presentationVideoLink,
                VideoLink: response.data.videoLink,
                facebookLink: response.data.facebookLink,
                googleFormLink: response.data.googleFormLink,
                duration: response.data.duration,
                pedagogicalMethods: response.data.pedagogicalMethods,
                objectives: response.data.objectives,
                detailledProgram: response.data.detailledProgram,
                prerequisite: response.data.prerequisite,
            })
            setPresentationId(response.data.presentationVideoLink.split('/')[3])
            if (response.data.videoLink) {
                setVideoId(response.data.videoLink.split('/')[3])
                setIsPaid(true)
            }
        })
        .catch(function(error: any) {
            alert('Une erreur est survenue ! Veuillez réessayer.')
        })
    }, [])

    if(training) {
        return(
            <div>
                <TrainingDetailCard id = {id}
                                    name={training.Name} 
                                    price={training.Price} 
                                    summary={training.Summary}
                                    presentationId={presentationId}
                                    videoId={videoId}
                                    isPaid={isPaid} 
                                    facebookLink={training.facebookLink}
                                    googleFormLink={training.googleFormLink}
                                    duration={training.duration}
                                    pedagogicalMethods={training.pedagogicalMethods}
                                    objectives={training.objectives}
                                    detailledProgram= {training.detailledProgram}
                                    prerequisite= {training.prerequisite} />
            </div>
        )
    }
    else {
        return(
            <div>
                Une erreur est survenue, rechargez la page.
            </div>
        )
    }

    
}